

























































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { TableEntry, TableColumnConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { FilterOptions } from '../../types';
import idb, { PRODUCTS_STORE_NAME } from '@/services/indexedDb.service';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';

const cssPrefix = 'msglicensedialog';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
    SwTextfield,
    SwExpandableTextfield,
  },
  directives: {
    tooltip,
  },
})
export default class ManageSharedLicense extends SwExtendedVue {

  cssPrefix = cssPrefix;

  @Prop()
  showManageSharedLicense: boolean;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  @Prop()
  serviceId: string;
  tenantDetails: any = {};
  assignedLic: number = 0;
  lsgwarning: string = '';
  instance: boolean = true;
  nodeCntErr: boolean = false;
  lsgTableData: TableEntry[] = [];
  invalidInput: boolean = false;
  mainLSGType: string = '';

  // search and filters
  searchON: boolean = false;
  searchText: string = '';
  filterPlaceholder: string = '';
  filterBoxToggle: boolean = true;
  placeholderText: string = 'Enter search text';
  unfiltered: TableEntry[] = [];
  isExpandSearchFilter: boolean = false;
  isExpandOtherFilter: boolean = false;
  otherFilter: boolean = true;
  selectedFilterBy: string = '';
  filterAttr: { 'Serial Number': string, 'Friendly Name': string } = { 'Serial Number':'', 'Friendly Name':'' };
  searchInputChips: FilterOptions[] = [];
  appliedFilter: any[] = [];
  serialNumberFilter: string = '';
  friendlyNameFilter: string = '';
  filterOptions: SelectOption[] = [
    { id:'Serial Number', label: (this.$t('products.prodSerialNumber')
      .toString()), value: 'serialnumber' },
    { id:'Friendly Name', label: (this.$t('products.friendlyName')
      .toString()), value: 'friendlyname' },
  ];
  friendlyname: string;
  // table
  get lsgColumnConfig(): TableColumnConfig[]  {
    return [
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        sorter: true,
        width: 200,
        title: (this.$t('products.serialNumber')
        .toString()),
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
          console.warn('mainLSGType ', this.mainLSGType);
          console.warn('lsgType ', data.entry?.lsgType);
          if (data.entry?.lsgType !== '' && this.mainLSGType !== '' && this.mainLSGType !== data.entry?.lsgType) {
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>{ data.entry.serialNumber }</div>
                <div
                  class="sharedCustomer-dark"
                  style={{ marginLeft: '5px' }}
                  v-tooltip={{
                    content: `${data.entry?.lsgMsg}`,
                    placement: 'left',
                    compact: true,
                  }}
                ></div>
              </div>
            ) as VNode;
          }
          return (
            <div>{ data.entry.serialNumber }</div>
          ) as VNode;
        },
      }, {
        key: 'friendlyName',
        dataKey: 'friendlyName',
        sorter: true,
        width: 150,
        title: (this.$t('products.friendlyName')
        .toString()),
      }, {
        key: 'productLine',
        dataKey: 'productLine',
        sorter: true,
        width: 150,
        title: (this.$t('products.productline')
        .toString()),
      }, {
        key: 'newNC',
        dataKey: 'newNC',
        sorter: true,
        width: 120,
        title: (this.$t('products.clientlicesnse1')
        .toString()),
      }, {
        key: 'nodeCount',
        dataKey: 'nodeCount',
        width: 150,
        title: (this.$t('products.newClientLicense')
        .toString()),
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
          return (
            <div>
              <SwTextfield
                name={data.entry.nodeCount}
          props-placeholder="0"
          props-value = {data.entry.nodeCount}
          on-input={(value: number) => {
            if (value >= 0) {
              data.entry.nodeCount = value;
              this.getNodeCount();
            }
          }}
          style="width: 100px"
              ></SwTextfield>
            </div>
          ) as VNode;
        },
      },
    ];
  }

  filter(selectedFilterBy: any) {
    this.appliedFilter.includes(selectedFilterBy) ? () => {} : this.appliedFilter.push(selectedFilterBy);
    this.otherFilter = !this.otherFilter;
    this.filterPlaceholder = selectedFilterBy;
    setTimeout(() => {
      try {
        if (this.$refs.textfieldexpandable?.hasOwnProperty('$children')) {
          (this.$refs.textfieldexpandable as SwExpandableTextfield).$children[0].$el.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
          }));
        }
      } catch (e) {
        console.warn(e);
      }
    },         100);
  }

  removeFilterBox(selectedKeys: string) {
    this.searchInputChips = this.searchInputChips.filter(filter => filter.filtertype !== selectedKeys);
    switch (selectedKeys) {
      case 'Search Text':
        this.searchText = '';
        break;

      case 'Serial Number':
        this.filterAttr['Serial Number'] = '';
        break;

      case 'Friendly Name':
        this.filterAttr['Friendly Name'] = '';
        break;
    }
    this.applyFilterSecond();
  }

  waitForTransition() {
    this.isExpandOtherFilter = false;
    setTimeout(() => {
      this.otherFilter = true;
    },         300);
  }

  toggleSearch() {
    setTimeout(() => {
      if (this.$refs.searchBoxTextField) {
        ((this.$refs.searchBoxTextField as SwTextfield).$refs.input as HTMLElement).focus();
      }
    },         100);
    this.searchON = !this.searchON;
  }

  closeDialog(value = false) {
    this.$emit('closeDialog', value);
  }

  getHeaderIconTooltip(text: string) {
    return {
      placement: 'top',
      compact: true,
      content: text,
    };
  }

  getNodeCount() {
    let total = 0;
    this.nodeCntErr = false;
    this.invalidInput = false;
    this.lsgTableData.forEach((element: any) => {
      total += +element.nodeCount;
    });
    if (total.toString() === 'NaN') {
      this.invalidInput = true;
    } else if (total > this.tenantDetails.nodeCount) {
      this.nodeCntErr = true;
    } else {
      this.assignedLic = total;
    }
    return total;
  }

  getTenantDetail() {
    this.nodeCntErr = false;
    const request = {
      serialNumber: this.serialNumber,
      serviceid: this.serviceId,
    };
    this.$store.dispatch('MswProductsStoreModule/getTenantDetail', request)
      .then((res: any) => {
        if (res.msgCode === 'MSWAPP:SUCCESS') {
          this.tenantDetails = res.hasOwnProperty('content') && res.content;
          this.lsgTableData = this.tenantDetails.hasOwnProperty('firewalls') ? this.tenantDetails.firewalls : [];
          this.unfiltered = this.tenantDetails.hasOwnProperty('firewalls') ? this.tenantDetails.firewalls : [];
          this.lsgTableData &&
          this.lsgTableData.length > 0 &&
          this.lsgTableData.forEach((obj : any, index : any) => {
            obj._key = index.toString();
          });
          this.mainLSGType = this.tenantDetails?.lsgType || '';
          console.warn(this.mainLSGType);
          if (this.tenantDetails.firewalls) {
            this.tenantDetails.firewalls.forEach((element: any) => {
              this.assignedLic += +element.nodeCount;
              element.newNC = element.nodeCount;
            });
          } else {
            this.instance = false;
          }
        }
        this.$store.commit('stopLoading');
      });
  }

  updateLSG(acceptMsg: string = '') {
    const firewalls: any = [];
    this.nodeCntErr = false;
    this.tenantDetails.firewalls.forEach((each: any) => {
      firewalls.push({ serialNumber: each.serialNumber, nodeCount: each.nodeCount });
    });
    const request:any = {
      firewalls,
      serialNumber: this.productDetails.serialNumber,
      serviceid: this.serviceId,
    };
    if (acceptMsg !== '') {
      request['acceptMsg'] = acceptMsg;
    } else {
      request['acceptMsg'] && (delete request['acceptMsg']);
    }
    this.$store.dispatch('MswProductsStoreModule/updateTenantLSG', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res?.msgCode === 'MSWAPP:SUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.closeDialog(true);
          idb.refreshStore(PRODUCTS_STORE_NAME);
        } else if (res?.msgCode === 'MSWAPP:INVALIDTOTALNODECOUNT') {
          this.nodeCntErr = true;
        }
        console.warn(res);
        if (res?.showConfirmation === 'YES') {
          console.warn('inside cc lsg condition');
          confirmService.confirm({
            status: 'major',
            message: res?.msgDesc || '',
            buttons: [
              {
                key: 'cancel',
                name: this.$t('common.cancel')
                .toString(),
              },
              {
                key: 'ok',
                name: this.$t('common.confirm')
                .toString(),
                isDefault: true,
              },
            ],
          })
          .then((isConfirmed: any) => {
            if (isConfirmed === 'ok') {
              this.updateLSG(res?.msgCode);
            }
          });
        }
      });
  }

  initiateSearchFilter() {
    this.applyFilterSecond();
  }

  applyFilter(searchKeys: string[] = ['serialNumber', 'friendlyName', 'productLine']) {
    if (this.searchText) {
      const key = this.searchText.toUpperCase();
      let flag = 0;
      this.lsgTableData = this.lsgTableData.filter((item) => {
        flag = 0;
        searchKeys.every((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          return true;
        });
        if (flag === 1) {
          return true;
        }
      });
      // tslint:disable-next-line:object-literal-key-quotes
      this.searchInputChips.some(filter => filter.filtertype === 'Search Text') ?
      this.searchInputChips.map((filter) => { if (filter.filtertype === 'Search Text') filter.filtervalue = this.searchText; }) :
      this.searchInputChips.push({ filtertype: 'Search Text', filtervalue: this.searchText });
    }
  }

  applyFilterSecond(): void {
    this.$store.commit('startLoading');
    let alteredlsgTableData: TableEntry[] = this.unfiltered;
    alteredlsgTableData = this.fFilter(alteredlsgTableData);
    alteredlsgTableData = this.sFilter(alteredlsgTableData);
    this.lsgTableData = alteredlsgTableData;
    this.applyFilter();
    this.$store.commit('stopLoading');
  }

  sFilter(alteredlsgTableData: TableEntry[]) {
    if (this.filterAttr['Serial Number']) {
      const key = this.filterAttr['Serial Number'].toUpperCase();
      const searchKeys: string[] = ['serialNumber'];
      let filteredTableData: TableEntry[] = [];
      let flag = 0;

      filteredTableData = alteredlsgTableData.filter((item) => {
        flag = 0;
        searchKeys.every((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          return true;
        });
        if (flag === 1) {
          return true;
        }
      });
      this.searchInputChips.some(filter => filter.filtertype === 'Serial Number') ?
      this.searchInputChips.map((filter) => { if (filter.filtertype === 'Serial Number') filter.filtervalue = this.filterAttr['Serial Number']; }) :
      this.searchInputChips.push({ filtertype: 'Serial Number', filtervalue: this.filterAttr['Serial Number'] });
      return filteredTableData;
    }
    return alteredlsgTableData;
  }

  fFilter(alteredlsgTableData: TableEntry[]) {
    if (this.filterAttr['Friendly Name']) {
      const key = this.filterAttr['Friendly Name'].toUpperCase();
      const searchKeys: string[] = ['friendlyName'];
      let filteredTableData: TableEntry[] = [];
      let flag = 0;

      filteredTableData = alteredlsgTableData.filter((item) => {
        flag = 0;
        searchKeys.every((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          return true;
        });
        if (flag === 1) {
          return true;
        }
      });
      this.searchInputChips.some(filter => filter.filtertype === 'Friendly Name') ?
      this.searchInputChips.map((filter) => { if (filter.filtertype === 'Friendly Name') filter.filtervalue = this.filterAttr['Friendly Name']; }) :
      this.searchInputChips.push({ filtertype: 'Friendly Name', filtervalue: this.filterAttr['Friendly Name'] });
      return filteredTableData;
    }
    return alteredlsgTableData;
  }

  resetData() {
    this.lsgTableData = this.unfiltered;
  }

  mounted() {
    this.getTenantDetail();
  }

}
